/**
 * Created by Denis Kuzin on 21 november 2025
 */

const AchievementExplanationWindow = Prefab.createWindow(
    "achievementexplanationwindow",
    "achievementexplanationwindow_prefab_json",
    { bundles: ["travel_book", "achievements"] }
);
